import React, { useState } from 'react';
import './FAQ.css';
import Title from "../Title/Title";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    { question: 'What is Tech-A-Thon?', answer: 'Tech-A-Thon is an annual tech event that challenges participants with various technical competitions and workshops.' },
    { 
      question: 'How can I register?', 
      answer: (
        <>
          You can register for individual events by visiting the links below:
          <ul>
            <li><a href="/event/1" target="_blank" rel="noopener noreferrer">Technical Quiz</a></li>
            <li><a href="/event/2" target="_blank" rel="noopener noreferrer">Debugging</a></li>
            <li><a href="/event/6" target="_blank" rel="noopener noreferrer">Product Development</a></li>
            <li><a href="/event/4" target="_blank" rel="noopener noreferrer">Project Presentation</a></li>
            <li><a href="/event/5" target="_blank" rel="noopener noreferrer">Capture The Flag</a></li>
            <li><a href="/event/10" target="_blank" rel="noopener noreferrer">UI/UX Designing</a></li>
            <li><a href="/event/7" target="_blank" rel="noopener noreferrer">Bot-A-Mata</a></li>
            <li><a href="/event/8" target="_blank" rel="noopener noreferrer">Game Jam</a></li>
            <li><a href="/event/9" target="_blank" rel="noopener noreferrer">SQL Detective</a></li>
            <li><a href="/event/3" target="_blank" rel="noopener noreferrer">Code Relay</a></li>
            <li><a href="/event/11" target="_blank" rel="noopener noreferrer">Data Dash</a></li>
          </ul>
        </>
      ),
    },
    { question: 'What are the eligibility criteria?', answer: 'The event is open to all second and third-year CSE and Cybersecurity students.' },
    { question: 'What should I bring to the event?', answer: 'Please bring a laptop, charger, and any other materials you may need for the competitions.' },
    { question: 'Is there a participation fee?', answer: 'No, participation is free of charge for all registered students.' }
  ];

  const handleToggle = index => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <div id="faq-main" style={{margin:"50px 0"}}>
      <Title title={"FAQS"} />
      </div>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button
              className={`faq-question ${activeIndex === index ? 'active' : ''}`}
              onClick={() => handleToggle(index)}
            >
              {faq.question}
            </button>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default FAQ;
